import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import { providerLogos } from 'common/services/sensors.service';
import Text from '../../components/base/Text';
import withGitIntegrationsModals from 'views/root/views/home/views/settings/views/RepositoriesV2/gitIntegrations/withGitIntegrationsModals';
import { redirectToSlack } from 'common/services/slack.service';
import { createJiraReauthModal } from 'modals/modal-options-factory';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import history from 'common/RouterHistory';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import useDispatchify from 'common/hooks/utils/useDispatchify';
import {
  getSensorAuthorizations as getSensorAuthorizationsCaller,
  toggleModal as toggleModalCaller,
  toggleSnackBar as toggleSnackBarCaller
} from 'state/callers';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { connectJiraOAuth2 } from 'common/services/jira-auth.service';
import useIsSensorSupportOAuth2 from 'common/hooks/auth/useIsSensorSupportOAuth2';

const PROVIDERS_TO_REAUTH_ACTIONS = {
  azure_devops: ({
    openReauthorizeModal,
    sensorAuthorization,
    toggleModal,
    gitIntegrations
  }) => {
    openReauthorizeModal({
      id: sensorAuthorization.id,
      sensor_name: sensorAuthorization.sensor_name,
      gitIntegrations,
      toggleModal
    });
  },
  github: ({
    openReauthorizeModal,
    sensorAuthorization,
    toggleModal,
    gitIntegrations
  }) => {
    openReauthorizeModal({
      id: sensorAuthorization.id,
      sensor_name: sensorAuthorization.sensor_name,
      gitIntegrations,
      toggleModal,
      url: sensorAuthorization.self_hosted_uri
    });
  },
  bitbucket_server: ({
    openReauthorizeModal,
    sensorAuthorization,
    toggleModal,
    gitIntegrations
  }) => {
    openReauthorizeModal({
      id: sensorAuthorization.id,
      sensor_name: sensorAuthorization.sensor_name,
      gitIntegrations,
      toggleModal,
      url: sensorAuthorization.self_hosted_uri
    });
  },
  bitbucket: ({
    openReauthorizeModal,
    sensorAuthorization,
    toggleModal,
    gitIntegrations
  }) => {
    openReauthorizeModal({
      id: sensorAuthorization.id,
      sensor_name: sensorAuthorization.sensor_name,
      gitIntegrations,
      toggleModal
    });
  },
  gitlab: ({
    openReauthorizeModal,
    sensorAuthorization,
    toggleModal,
    gitIntegrations
  }) => {
    openReauthorizeModal({
      id: sensorAuthorization.id,
      sensor_name: sensorAuthorization.sensor_name,
      gitIntegrations,
      toggleModal,
      url: sensorAuthorization.self_hosted_uri
    });
  },

  JIRA: ({ toggleModal, sensorAuthorization, isSupportOAuth2 }) => {
    if (isSupportOAuth2) {
      connectJiraOAuth2({ sensor_auth_id: sensorAuthorization.id });
    } else {
      toggleModal(createJiraReauthModal());
    }
  },
  slack: ({ sensorAuthorization }) => {
    redirectToSlack(null, sensorAuthorization.id, true);
  },
  // not handling microsoft teams and clubhouse because they are still not implemented
  clubhouse: _.noop,
  azure_ad_oauth2: _.noop,
  azure_boards: () =>
    history.push(`${AppRouter.PROJECT_MANAGEMENT.path}?isOrgSettings=true`)
};

export default withGitIntegrationsModals(
  ({ includeLogo, sensorAuthorization, ...withGitIntegrationModalProps }) => {
    const account = useSelector(myAccountSelector);
    const gitIntegrations = useSelector(gitIntegrationsSelector);
    const getSensorAuthorizations = useDispatchify(
      getSensorAuthorizationsCaller
    );
    const toggleModal = useDispatchify(toggleModalCaller);
    const toggleSnackBar = useDispatchify(toggleSnackBarCaller);
    const isSupportOAuth2 = useIsSensorSupportOAuth2(sensorAuthorization);

    const sensorName = _.get(sensorAuthorization, 'sensor_name');
    const isMultiTokenEnabled = !!sensorAuthorization?.is_multi_token_enabled;

    if (
      account &&
      (account.type_id === ACCOUNT_TYPES_MAP.Primary ||
        account.id === sensorAuthorization.account_id)
    ) {
      return (
        <Tooltip
          title='For reauth multi-tokens integration, please reach out to customer support'
          disableHoverListener={!isMultiTokenEnabled}
        >
          <div className='w-fit'>
            {/* should wrap with a div to allow Tooltip display on Disabled Button */}
            <LBButton
              variant='outline'
              disabled={isMultiTokenEnabled}
              onClick={() => {
                _.get(
                  PROVIDERS_TO_REAUTH_ACTIONS,
                  sensorAuthorization.sensor_name,
                  _.noop
                )({
                  ...withGitIntegrationModalProps,
                  sensorAuthorization,
                  isSupportOAuth2,
                  gitIntegrations,
                  getSensorAuthorizations,
                  toggleModal,
                  toggleSnackBar
                });
              }}
            >
              {includeLogo && (
                <img
                  alt={`${sensorName} logo`}
                  src={providerLogos[sensorName]}
                  style={{ width: '1.7rem', paddingRight: '0.5rem' }}
                />
              )}
              Reauthorize
            </LBButton>
          </div>
        </Tooltip>
      );
    }
    return (
      <Text size='large' weight='400'>
        Please contact your organization's admin
      </Text>
    );
  }
);
